import { AxiosError } from 'axios';
import api from '../../../services/cle';
import { useEffect, useRef, useState } from 'react';
import UsuarioExclusao from '../../usuario/exclusao';
import { useAppSelector } from '../../../store/hooks';
import { ApiError, ListagemProps } from '../../../services/tipos';
import { Listagem } from '../../../rxlib/components/layout/listagem';
import { ConfiguracoesTabela } from '../../../rxlib/components/table';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import AcessoBloqueado from '../../../rxlib/components/acesso-bloqueado';
import { RxlibLayout } from '../../../rxlib/components/layout/rxlib-Layout';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import Breadcrumb, { BreadcrumbItem } from '../../../rxlib/components/breadcrumb';
import { obterQuantidadeParaPular, tratarErroApi } from '../../../rxlib/services/utilitarios';

function UsuarioListagem(props: ListagemProps) {
    const [usuarios, setUsuarios] = useState<[{}]>([{}]);
    const [idUsuario, setIdUsuario] = useState<string>('');
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [showExclusao, setShowExclusao] = useState<boolean>(false);
    const [quantidadeTotal, setQuantidadeTotal] = useState<number>(0);
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(true);

    const handleHide = () => setShowWarning(false);

    const handleHideExclusao = () => setShowExclusao(false);

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Usuários', link: '' },
    ];

    const configuracoesTabela: ConfiguracoesTabela = {
        mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
        colunas: [
            { nome: 'Nome', campo: 'Nome', tipo: 'string' },
            { nome: 'E-mail', campo: 'Email', tipo: 'string' },
        ],
    }

    const quantidadeRegistrosPorPagina = 10;
    const quantidadeParaPular = obterQuantidadeParaPular(parseInt(props.match.params.pagina), quantidadeRegistrosPorPagina);

    const paginaAnteriorRef = useRef<number>(quantidadeParaPular);

    const temPermissao = usuarioTemPermissao(token, 'usuario_visualizar');
    const linkNovo = usuarioTemPermissao(token, 'usuario_novo') ? '/usuario/novo' : '';
    const linkEdicao = usuarioTemPermissao(token, 'usuario_editar') ? '/usuario/editar' : '';
    const handleExclusao = usuarioTemPermissao(token, 'usuario_excluir') ? handleExcluir : undefined;

    useEffect(() => {
        setRealizarConsulta(true);
    }, [quantidadeParaPular]);

    useEffect(() => {
        if ((temPermissao) && (realizarConsulta)) {
            const mudouPagina = paginaAnteriorRef.current !== quantidadeParaPular;
            paginaAnteriorRef.current = quantidadeParaPular;

            if (!mudouPagina) {
                setCarregando(true);
            }

            api.get(`/OData/Usuario?$count=true&$top=${quantidadeRegistrosPorPagina}&$skip=${quantidadeParaPular}`)
                .then(response => {
                    setTimeout(() => {
                        setQuantidadeTotal(response.data['@odata.count']);
                        setUsuarios(response.data.value);
                        setRealizarConsulta(false);
                        setCarregando(false);
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregando(false);
                    setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
                    setShowWarning(true);
                });
        }
    }, [quantidadeParaPular, temPermissao, realizarConsulta]);

    function handleExcluir(id: string) {
        setIdUsuario(id);
        setShowExclusao(true);
    }

    function tratarErro(error: AxiosError<ApiError>, mensagem: string) {
        setCarregando(false);
        setMessageWarning(tratarErroApi(error, mensagem));
        setShowWarning(true);
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <Listagem
                    campoId='Id'
                    linkNovo={linkNovo}
                    fonteDados={usuarios}
                    tipoBotaoAcao='button'
                    listagemDetalhe={false}
                    carregando={carregando}
                    linkListagem='/usuario'
                    linkEdicao={linkEdicao}
                    onExcluir={handleExclusao}
                    descricao='Listagem de usuários'
                    linkVisualizacao='/usuario/visualizar'
                    configuracoesTabela={configuracoesTabela}
                    quantidadeTotalRegistros={quantidadeTotal}
                    paginaAtual={parseInt(props.match.params.pagina)}
                    quantidadeRegistrosPorPagina={quantidadeRegistrosPorPagina} />
                <ModalWarning
                    show={showWarning}
                    onHide={handleHide}
                    message={messageWarning} />
                <AcessoBloqueado
                    permissao={temPermissao} />
                <UsuarioExclusao
                    show={showExclusao}
                    idUsuario={idUsuario}
                    tratarErro={tratarErro}
                    onHide={handleHideExclusao}
                    onExcluir={setRealizarConsulta} />
            </RxlibLayout>
        </>
    );
}

export default UsuarioListagem;